module.exports = __webpack_public_path__ + "static/img/wolves.514b324.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/wolves.jpg
// module id = SQo4
// module chunks = 1